module.exports = __webpack_public_path__ + "img/AIDT-waw-logo.6f39d5dd.png";